<template>
<div v-show="stayFun" class="page-funreport" @touchmove="loadMoreFriend()">
	<img v-bind:src="funreport.pic.replace('../', './')" style="display:none;">
	<!-- 趣味报告标题 -->
	<fun-head></fun-head>
	<!-- 趣味报告标题 -->
	<!-- 趣味报告 -->
	<fun-report></fun-report>
	<!-- 趣味报告 -->
	<!-- actions -->
	<div class="funreport-actions">
		<!-- 购买专业报告 -->
		<div v-if="!is_free & !shareLock">
			<p class="unlock-tips">好奇的，来打赏{{price}}元</p>
			<p class="unlock-tips">心理学家深度解读你的性格、爱情、职场特质</p>
			<a @click="buyReport()" class="btn mg0" >好的，GO！</a>
		</div>

		<!-- 限免但是要分享 -->
		<a @click="funToShare()" class="btn" v-if="is_free & !shareLock">限时免费！马上解锁专业报告</a>
		<p class="unlockPeople" v-if="is_free & !shareLock">已有{{selfResult.unlock_num}}人成功解锁专业报告</p>
		<!-- 已经分享 -->
		<a href="javascript:;" class="btn" @click="toProReport()" v-if="shareLock">查看专业报告</a>
		<a href="javascript:;" class="btn" @click="toggleShare()" v-if="shareLock">看看好友的动物画像</a>
	</div>

	<!-- 好友列表 -->
	<div v-if="shareLock | !is_free">
		<friend-list></friend-list>
	</div>
	<!-- 好友列表 -->



	<!-- 各种遮罩 -->
	<!--
		shareMask
		shareLock = 1 表示已经解锁过
	-->
	<div v-if="shareMask&shareLock" @click="toggleShare()">
		<unlock-share></unlock-share>
	</div>
	<div v-if="shareMask&!shareLock" @click="toggleShare()">
		<free-share></free-share>
	</div>

	<yxl-logo></yxl-logo>
	<!-- 解锁后的初次分享后 -->
	<div v-if="qrCodeMask&isFirstShare" @click="oneQrcode()">
		<qrcode-mask></qrcode-mask>
	</div>
</div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'
import axios from 'axios'
import APIS from '../apis.js'
import store from '../store.js'
import router from '../router.js'

import logo from '../components/yxl-logo.vue'
import funHead from '../components/funHead.vue'
import funReport from '../components/funBody.vue'
import freeShare from '../components/freeShare.vue'
import unlockShare from '../components/unlockShare.vue'
import friendList from '../components/funFriendList.vue'
import qrcodeMask from '../components/qrcodeMask.vue'



export default {
	name: 'funreportPage',
	components: {
		yxlLogo: logo,
		funHead: funHead,
		funReport: funReport,
		freeShare: freeShare,
		unlockShare: unlockShare,
		friendList: friendList,
		qrcodeMask: qrcodeMask
	},
	beforeRouteEnter (to, from, next){
		axios.get(APIS.getSelfReport, {
			params: {
				'isWeiXin': to.query.isWeiXin?to.query.isWeiXin:0,
			}
		}).then(function(res) {
			var res = res.data;
			if(res.code==200) {
				store.commit('setFunreport', {report:res.data,gender:res.data.gender});
				store.dispatch('getFriendList', res.data.activate_id);
			} else if (res.code == 1001){
          //拿授权
			    window.location.href = APIS.shouquan + '?callback=' + encodeURIComponent(location.href);
      }
		}).then(function() {
			next(vm => {});
		}).catch(function(error){
			console.log(error);
		})

	},
	data() {
		return {
			shareMask: false,
			isFirstShare: true,
			qrCodeMask: false,
			page: 1,
			oldUnlock: 0,
			friendListEnd: 0,
		}
	},
	created(){
    document.title = '你是萌兽，还是猛兽？';
	},
	mounted() {
		document.body.scrollTop = 0;
		if( this.selfResult!=undefined & this.selfResult.unlock == '1' & this.stayFun != true) {
			router.replace({
				name: 'proreport',
				path: '/proreport',
				query: {
					isWeiXin: this.$route.query.isWeiXin?this.$route.query.isWeiXin:0,
          channel_id: this.channel_id
				}
			})
		} else {
			this.setStayFun(true);
			document.querySelector('.page-funreport').style.minHeight = window.screen.availHeight - 45 + 'px';
		}

		this.$data.oldUnlock = this.shareLock+'';
		this.setFinishTest(true);
		// 微信分享
		let that = this;
		wx.ready(function(){});
		wx.ready(function() {
			var shareConfig = {
				title: '天了噜，' + that.selfResult.nickname + ' 灵魂深处竟然是神兽' + that.funreport.animal +'！', // 分享标题
				desc: '每个人身体里都有一只动物，代表着你最原始的兽性',
				link: 'http://static.xinli001.com/animalPicture/index.html?fromChannel=' + that.channel_id +'#/sharereport/'+that.selfResult.activate_id + '?' + Math.random(), // 分享链接
				imgUrl: 'http://static.xinli001.com/animalPicture/'+ that.funreport.pic.replace('../', ''), // 分享图标
			};
			setWxShare()
			function setWxShare() {
				wx.onMenuShareAppMessage({
					title: shareConfig.title, // 分享标题
					desc: shareConfig.desc,
					link: shareConfig.link, // 分享链接
					imgUrl: shareConfig.imgUrl,
					type: 'link', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function () {
					  that.unLockReport(that.selfResult.activate_id);
					  // 解了锁，并且之前未解锁的，就显示二维码
					  if(that.$data.oldUnlock=='0' & that.shareLock) {
						  that.qrCodeMask = true;
					  } else if (that.$data.oldUnlock=='1' & that.shareLock){
						  that.qrCodeMask = true;
					  } else {
					  	that.qrCodeMask = false;
					  }
					  that.shareMask = false;
					  zhuge.track('测评活动', {
						    '被分享页面' : '趣味报告页',
						});
					},
					cancel: function () {
					  // 用户取消分享后执行的回调函数
					}
				});

	      wx.onMenuShareTimeline({
	        title: shareConfig.title, // 分享标题
	        link: shareConfig.link, // 分享链接
	        imgUrl: shareConfig.imgUrl, // 分享图标
	        success: function () {
					  that.unLockReport(that.selfResult.activate_id);
		         // 解了锁，并且之前未解锁的，就显示二维码
					  if(that.$data.oldUnlock=='0' & that.shareLock) {
						  that.qrCodeMask = true;
					  } else if (that.$data.oldUnlock=='1' & that.shareLock){
						  that.qrCodeMask = true;
					  } else {
					  	that.qrCodeMask = false;
					  }
					  that.shareMask = false;
					  zhuge.track('测评活动', {
						    '被分享页面' : '趣味报告页',
						});
	        },
	        cancel: function () {
	            // 用户取消分享后执行的回调函数
	        }
	      });

				wx.hideMenuItems({
			    menuList: [
						'menuItem:share:qq',
						'menuItem:share:weiboApp',
						'menuItem:share:QZone',
						"menuItem:openWithSafari",
						"menuItem:copyUrl"
			    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
				});

	      wx.showMenuItems({
				    menuList: [
				     	"menuItem:share:appMessage",
							"menuItem:share:timeline"
				    ]
				});
			}
		});
	},
	computed: {
		price() {
			let p = this.selfResult.discount_price?this.selfResult.discount_price:'0',
					result = '';

			if( p.split('.').length>=2 ) {
				result = p.split('.')[0]+'.'+p.split('.')[1].slice(0, 2)
			} else {
				result = p.split('.')[0]+'.00'
			}

			return result;
		},
		...mapState({
				funreport: state => state.funreport,
				selfResult: state => state.selfResult,
				shareLock: state => state.selfResult.unlock,
				is_free: state => state.selfResult.is_free,
				friendList: state => state.friendList,
				stayFun : state => state.stayFun,
				channel_id: state => state.channel_id
		})
	},
	methods: {
		...mapMutations([
			'setshareLock',
			'setBusy',
			'setFriendList',
			'setFinishTest',
			'setStayFun',
			'setChannelId'
		]),
		...mapActions([
			'unLockReport',
			'getSelfReport',
			'unLockPeopleAdd',
			'buyProReport'
		]),
		update() {
			this.$data
		},
		funToShare() {
			this.toggleShare();
			this.unLockPeopleAdd();
		},
		toggleShare(share){
			this.$data.shareMask = !this.$data.shareMask;
			// 微信分享成功后调用
		},
		toProReport() {
			router.push({
				path: '/proreport/',
				name: 'proreport',
				query: {
					isWeiXin: this.$route.query.isWeiXin?this.$route.query.isWeiXin:0,
          channel_id: this.channel_id
				},
			});
		},
		oneQrcode() {
			this.$data.qrCodeMask = !this.$data.qrCodeMask;
			this.$data.isFirstShare = false;
		},
		buyReport() {
			this.buyProReport({
				test_id: 11,
				channel_id: this.channel_id
			});
		},
		loadMoreFriend() {
			if(this.$data.friendListEnd) {
				return;
			}
			let busy = this.$store.state.busy,
					that = this;
			let offsetBottom = document.body.scrollHeight - document.querySelector('body').scrollTop - window.screen.availHeight;
			if(!busy & (offsetBottom < 50)) {
				that.setBusy(true);
				axios.get(APIS.friends, {
					params: {
						id: that.selfResult.activate_id,
						page: that.$data.page+1
					}
				}).then(function(res) {
					that.setBusy(false);
					if(res.data.code==200) {
						if(res.data.data.length>0) {
							that.$data.page++
							console.log(that.$data.page);
							for(let i = 0; i < res.data.data.length; i++) {
								that.friendList.push(res.data.data[i]);
							}
							that.setFriendList(that.friendList)
						} else {
							that.$data.friendListEnd = true;
						}
					}
				}).catch(function(error) {
					that.setBusy(false);
					console.log(error);
				})
			}
		}
	}
}
</script>

<style scoped lang="scss">
$font-size-base:32; // Base on 320px;
@function topx($rem) {
  @return $rem/$font-size-base;
}
.page-funreport {
	position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background: url('../../static/images/all_bg.png');
  padding-bottom: topx(80rem * 0.5);
	.funreport-actions {
		font-size: 0;
		text-align: center;
		margin-top: topx(50rem * 0.5);
		margin-bottom: topx(60rem * 0.5);
		.unlock-tips {
			font-size: topx(16rem * 0.5);
			color: #757575;
			margin: 0 0 topx(5rem) 0;
		}
		.btn {
			display: inline-block;
			height: topx(60rem * 0.5);
			padding: 0 topx(12rem * 0.5);
			margin-left: topx(93rem * 0.5);
			font-size: topx(24rem * 0.5);
			color: #81600e;
			background: #edc96f;
			line-height: topx(62rem * 0.5);
			border-radius: topx(10rem * 0.5);
			border: topx(3rem * 0.5) solid #e6ae24;
			&:first-child, &.mg0 {
				margin: 0;
			}

		}
		.unlockPeople {
			color: #868686;
			font-size: topx(22rem * 0.5);
		}
	}

	.qrCodeMask {
		.mask {
			position: fixed;
			z-index: 99;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: #000;
			opacity: .75;
		}
		img {
			width: topx(123rem * 0.5);
			height: topx(123rem * 0.5);
			position: fixed;
			z-index: 100;
			top: 50%;
			left: 50%;
			margin: topx(-123rem * 0.5) 0 0 topx(-123rem * 0.5);
		}
	}
}
</style>



// WEBPACK FOOTER //
// funreport.vue?046bf28a